<template>
  <div class="footer-wrapper">
    <div
      class="custom-footer"
      v-on="swp_events"
    >
      <ReactMobileMenu
        v-if="useReactMenu"
        :showUpgrade="!gameformatPurchased"
        class="custom-footer_menu-icon"
      />
      <div v-else>
        <div
          class="custom-footer_menu-icon"
          @click="
            () => {
              drawer = true
              loadNolt()
            }
          "
        >
          <div class="position-relative">
            <i class="mdi mdi-menu"></i>
            <div
              v-if="freshChatMessages"
              class="notifCircle"
            >
              {{ freshChatMessages > 99 ? '99+' : freshChatMessages }}
            </div>
          </div>
        </div>
        <div
          class="footer-drawer_overlay"
          :class="{ 'footer-drawer_overlay_visible': drawer }"
          @click="drawer = false"
        ></div>

        <div
          class="footer-drawer elevation-4"
          :class="{ 'footer-drawer_open': drawer }"
          @click="drawer = false"
        >
          <div class="d-flex f-align-center position-relative">
            <router-link
              :to="{ name: links_menu[0].pathName }"
              class="footer_logo w-100"
            >
              <NavCard
                :isActive="$route.name === links_menu[0].pathName"
                :item="links_menu[0]"
                class="navcard_menu navcard_menu-trigger font-eina02"
                data-tst="gwiz_logo"
                :style="`
              --icon-size:1.5rem;
              --icon-align-items: center;
              --padding: 1rem 1rem;
              --title-weight: 700;
              --clr-text:var(--clr-grey-2);
              --clr-text:var(--clr-white-0);
              --clr-text-active:var(--clr-white-0);
              --clr-text-hover:var(--clr-white-0);
              --clr-icon-active:var(--clr-primary);
              --clr-icon-hover:var(--clr-primary);
              --title-transform: normal;
               `"
              >
                <template #icon>
                  <Logo style="fill: var(--clr-primary); position: absolute" />
                </template>
              </NavCard>
            </router-link>
            <div
              style="position: absolute; right: 0"
              class="ml-auto pa-3 mdi mdi-refresh text-large clr-grey"
              @click="reloadPage"
            ></div>
          </div>

          <div class="d-flex justify-center">
            <router-link
              v-if="$store.getters.user_has_flag('CR_REPORTS')"
              :class="links_menu[1].pathName === $route.name ? 'router-link-active' : ''"
              :to="{ name: 'UserCredits' }"
              data-tst="study_menu_link_main"
            >
              <CreditsBalanceCard
                style="
                  display: flex;
                  justify-content: center;
                  --padding: 0.5rem 0 0.5rem 0;
                  --padding-text: 0 0 0 0.5rem;
                "
              />
            </router-link>
          </div>

          <div class="bt-grey w-100"></div>
          <div class="d-flex flex-1 mt-2">
            <GwBtnClipboard
              class="flex-1 mx-2"
              copyUrl
            >
            </GwBtnClipboard>
          </div>
          <div
            v-if="!globals_pwa_installed && !$store.getters.user_has_flag('REACT_MOBILE_MENU')"
            class="d-flex flex-1 mt-2"
          >
            <div
              class="mx-2 gw_btn gw_btn_large weight_500 flex-1 gw_btn_primary"
              @click="$store.dispatch('globals_action', 'install_pwa')"
            >
              <i class="mr-2 mdi mdi-arrow-down-bold-circle-outline text-large"></i>
              {{ $t('btn.install_app') }}
            </div>
          </div>
          <div
            v-if="!gameformatPurchased"
            class="d-flex flex-1 mt-2"
          >
            <div
              class="mx-2 gw_btn gw_btn_large weight_500 flex-1 gw_btn_primary"
              style="min-height: 2rem"
              @click="$router.push({ name: 'Subscription' })"
            >
              <i class="mr-2 mdi mdi-crown text-large"></i>

              {{ $t('btn.upgrade') }}
            </div>
          </div>

          <div
            v-if="$store.getters.user_has_flag('CHAT_WIDGET')"
            class="bt-grey w-100 my-2"
          ></div>

          <NavCard
            v-if="$store.getters.user_has_flag('CHAT_WIDGET')"
            :item="{
              title: $t('common.chat_with_us'),
            }"
            class="navcard_menu navcard_menu-trigger"
            :style="navCardStyle"
            :hasSub="false"
            @click="openChat"
          >
            <template #icon>
              <div class="position-relative">
                <div class="mdi mdi-chat"></div>
                <div
                  v-if="freshChatMessages"
                  class="notifCircle"
                >
                  {{ freshChatMessages > 99 ? '99+' : freshChatMessages }}
                </div>
              </div>
            </template>
          </NavCard>

          <div class="bt-grey w-100 my-2" />

          <component
            :is="item.href ? 'a' : 'router-link'"
            v-for="(item, iIdx) in [
              ...links_study,
              ...($i18n.g1 ? [] : [links_all.external_HelpCenter]),
            ]"
            :key="`${item.pathName}_${iIdx}`"
            v-bind="
              item.href
                ? {
                    href: item.href,
                    target: '_blank',
                  }
                : {
                    to: { name: item.pathName, query: item.query || {} },
                  }
            "
            :class="[{ 'router-link-active': item.active }]"
          >
            <NavCard
              :class="{ opacity_7: item.disabled }"
              :item="item"
              class="navcard_menu navcard_menu-trigger navcard_router-link"
              :style="`${navCardStyle}${item.style};`"
              :hasSub="false"
            />
          </component>

          <div class="bt-grey w-100 my-2" />
          <router-link
            v-for="(item, iIdx) in links_practice_footer_drawer"
            :key="`${item.pathName}_${iIdx}`"
            class="only-exact-active"
            :to="{ name: item.pathName }"
            :class="{ 'no-events': item.disabled }"
          >
            <NavCard
              :class="{ opacity_7: item.disabled }"
              :item="item"
              class="navcard_menu navcard_menu-trigger navcard_router-link"
              :style="`${iIdx !== 0 ? 'padding-left:1.75rem;' : ''}${
                item.tag_live ? tagLiveStyle : navCardStyle
              }`"
              :hasTag="!!item.tag_live"
              :hasSub="false"
            />
          </router-link>
          <div class="bt-grey w-100 my-2" />
          <router-link
            v-for="(item, iIdx) in $store.getters.user_has_flag('HHV2') ? links_analyze_v4 : []"
            :key="`${item.pathName}_${iIdx}`"
            :to="{ name: item.pathName }"
            :class="{ 'no-events': item.disabled }"
          >
            <NavCard
              :class="{ opacity_7: item.disabled }"
              :item="item"
              :hasTag="true"
              class="navcard_menu navcard_menu-trigger navcard_router-link"
              :style="`${iIdx !== 0 ? 'padding-left:1.75rem;' : ''}${navCardStyle};${item.style || ''}`"
              :hasSub="false"
            />
          </router-link>
          <router-link
            v-if="$store.getters.user_has_flag('GTO_REP')"
            :key="links_all.GtoReports.pathName"
            :to="{ name: links_all.GtoReports.pathName }"
          >
            <NavCard
              :hasTag="true"
              :item="links_all.GtoReports"
              class="navcard_menu navcard_menu-trigger navcard_router-link"
              :style="`padding-left:1.75rem;${navCardStyle};${links_all.GtoReports.style || ''}`"
              :hasSub="false"
            />
          </router-link>
          <div class="bt-grey w-100 my-2" />
          <router-link
            v-for="(item, iIdx) in links_settings.filter(i => i.pathName !== 'UserHotkeys')"
            :key="`${item.pathName}_${iIdx}`"
            :to="{ name: item.pathName }"
            :class="{ 'no-events': item.disabled }"
          >
            <NavCard
              :class="{ opacity_7: item.disabled }"
              :item="item"
              class="navcard_menu navcard_menu-trigger navcard_router-link"
              :style="navCardStyle"
              :hasSub="false"
            />
          </router-link>

          <div
            v-if="$store.getters.user_has_flag('NOLT')"
            class="bt-grey w-100 my-2"
          />

          <NavCard
            v-if="$store.getters.user_has_flag('NOLT')"
            class="navcard_menu navcard_menu-trigger init_nolt_btn"
            :style="navCardStyle"
            :item="{
              icon: 'mdi-comment-edit',
              title: $t('common.make_a_suggestion'),
            }"
          />

          <div class="bt-grey w-100 mt-2"></div>
          <NavCard
            :item="logOut"
            class="navcard_menu navcard_menu-trigger navcard_router-link"
            :style="navCardStyle"
            :hasSub="false"
            @click="handleClick(logOut)"
          />
        </div>
      </div>

      <HorizolnalScroller
        ref="scroller"
        class="trainer-advanced-filter-overviwe traefilterover"
        :innerCssClass="`d-flex`"
        style="--clr-arrow-back: var(--clr-black-1)"
      >
        <NavCard
          v-for="(item, iIdx) in footerOptions"
          :key="`${item.name}_${iIdx}`"
          :item="item"
          :class="[
            item.css_class,
            { navcard_active: $route.name === item.pathName },
            { 'no-events opacity_4': item.disabled },
          ]"
          :hasText="false"
          :hasTitle="false"
          class="navcard_no-hover navcard_pyramid text-nowrap"
          style="
            --icon-size: 1.5rem;
            --height: var(--footer-height);
            --width: 100%;
            --clr-text: var(--clr-grey-2);
            --clr-tag-back: var(--clr-black-4);
          "
          :hasSub="false"
          :hasTag="false"
          @click="handleClick(item)"
        />
      </HorizolnalScroller>
    </div>
  </div>
</template>

<script>
import ReactMobileMenu from '@/components/AppBar/ReactMobileMenu.vue'
import GwBtnClipboard from '@/components/lib/GwBtnClipboard/GwBtnClipboard'
import HorizolnalScroller from '@/components/HorizolnalScroller/HorizolnalScroller'
import CreditsBalanceCard from '@/components/NavCard/CreditsBalanceCard.vue'
import { openChat } from '@gto/widgets/fresh-chat'
import tier_mix from '@/mixins/tier_mix'
import links_mix from '@/mixins/links_mix'
import swipe_mix from '@/mixins/swipe_mix'
import Logo from '@/assets/logo.svg'
import { loadNoltWidget } from '@gto/widgets/nolt'

export default {
  name: 'AppFooter',
  components: {
    Logo,
    GwBtnClipboard,
    HorizolnalScroller,
    CreditsBalanceCard,
    ReactMobileMenu,
  },
  mixins: [tier_mix, links_mix, swipe_mix],
  data() {
    this.namespace = '' // tier_mix needs namespace
    this.tagLiveStyle = `
        --height: var(--item-height);--clr-text:var(--clr-grey-2);
        --tag-padding:0 0.25rem;--clr-tag:var(--clr-white-0); --clr-tag-back: var(--clr-error);
        `
    return {
      navCardStyle: `--height: var(--item-height);--clr-text:var(--clr-grey-2); --clr-tag-back:var(--clr-black-4);`,
      drawer: false,
    }
  },
  methods: {
    swpLeft(eventData) {
      this.drawer = false
    },
    handleClick(item) {
      if (item.fn) {
        item.fn()
      }
      if (item.href) {
        // external link
        window.open(item.href, '_blank')
        return
      }
      if (item.pathName) {
        this.$router.push({ name: item.pathName }).catch(() => {})
      }
    },
    reloadPage() {
      window.location.reload()
    },
    openChat,
    loadNolt() {
      if (!this.$store.getters.user_has_flag('NOLT')) return
      loadNoltWidget()
    },
  },
  computed: {
    useReactMenu() {
      return this.$store.getters.user_has_flag('REACT_MOBILE_MENU')
    },
    freshChatMessages() {
      return this.$store.getters.freshChatMessages
    },
    footerOptions() {
      let res = []
      if (this.$route.name === 'Dashboard' || this.$route.name === 'Coaching') {
        res = this.links_menu.filter(i => i.pathName !== 'Dashboard')
      }
      if (this.$route.name === 'StudySolutions') {
        res = [
          {
            title: this.$t('links.study_solutions'),
            icon: 'mdi-school',
            id: 'solutions',
            is_default: true,
            css_class: 'navcard_active',
          },
          {
            title: this.$t('links.study_graph'),
            icon: 'mdi-poll',
            fn: () => {
              this.$store.dispatch('router_set_dialogs', 'study-mobile-graph-dialog')
            },
          },
          {
            title: this.$t('common.view'),
            icon: 'mdi-eye',
            fn: () => {
              if (this.$store.getters.sw_tabs_study === 'reports') {
                this.$store.dispatch('router_set_dialogs', 'study-reports-view-dialog')
              } else {
                this.$store.dispatch('router_set_dialogs', 'study-strategy-view-dialog')
              }
            },
          },
        ]
      }

      if (this.$route.name === 'PracticeTrainer') {
        const drills = this.$store.getters.panel_drills
        const left = this.$store.getters.panel_left
        const right = this.$store.getters.panel_right

        let mainLinkActive = false
        if (this.$store.getters.hands_configure) {
          mainLinkActive = !drills
        } else {
          mainLinkActive = !right && !left
        }
        const linkTrainer = this.links_getItem({
          pathName: 'PracticeTrainer',
          options: this.links_practice_all,
        })
        res = [
          {
            ...linkTrainer,
            css_class: mainLinkActive ? 'navcard_active' : 'navcard_not-active',
            fn: () => {
              this.$store.state.panels.panel_drills = false
              this.$store.state.panels.panel_right = false
              this.$store.state.panels.panel_left = false
            },
          },
          {
            id: 'drills',
            title: this.$t('common.drills'),
            icon: 'mdi-target',
            css_class: drills ? 'navcard_active' : '',
            fn: () => {
              this.$store.state.panels.panel_drills = !drills
            },
          },
          {
            id: 'controls',
            title: this.$t('common.controls'),
            icon: 'mdi-gamepad',
            css_class: left ? 'navcard_active' : '',
            fn: () => {
              this.$store.state.panels.panel_right = false
              this.$store.state.panels.panel_left = !left
            },
          },
          {
            id: 'info',
            title: this.$t('links.practice_info'),
            icon: 'mdi-lightbulb',
            css_class: right ? 'navcard_active' : '',
            fn: () => {
              this.$store.state.panels.panel_right = !right
              this.$store.state.panels.panel_left = false
            },
          },
        ].filter(i => {
          if (this.$store.getters.hands_configure) {
            return i.id !== 'controls' && i.id !== 'info'
          }
          return i.id !== 'drills'
        })
      } else if (this.$route.name === 'PracticeRangeBuilder') {
        res = [
          this.links_all.PracticeRangeBuilder,
          {
            title: this.$t('common.view'),
            icon: 'mdi-eye',
            fn: () => {
              if (this.$store.getters.sw_tabs_study === 'reports') {
                this.$store.dispatch('router_set_dialogs', 'study-reports-view-dialog')
              } else {
                this.$store.dispatch('router_set_dialogs', 'study-strategy-view-dialog')
              }
            },
          },
        ]
      } else if (window.location.href.includes('/practice')) {
        res = this.links_practice_footer
      }
      if (window.location.href.includes('/analyze')) {
        res = this.links_analyze_v4
      }
      if (window.location.href.includes('/user')) {
        res = this.links_settings.filter(i => i.pathName !== 'UserHotkeys')
      }
      if (window.location.href.includes('/study-plans')) {
        res = [this.links_all.StudyPlansDashboard, this.links_all.external_HelpCenter]
      }
      // console.log(res)
      return res
    },

    logOut() {
      return {
        title: this.$t('links.log_out'),
        id: 'log_out',
        icon: 'mdi-logout',
        fn: () => {
          this.$store.dispatch('api_logout')
        },
      }
    },
    globals_action() {
      const { globals_action } = this.$store.getters
      return globals_action
    },
    globals_pwa_installed() {
      const { globals_pwa_installed } = this.$store.getters
      return globals_pwa_installed
    },
  },
}
</script>
<style lang="scss" scoped>
.notification-bell-drawer {
  position: absolute;
  top: 8px;
  right: 16px;
}

.footer {
  &_lang-menu {
    position: absolute;
    right: 0rem;
    top: 0.5rem;
  }
}
.footer-wrapper {
  --footer-height: var(--glo-footer-height);
  --item-height: 2.75rem;
  width: 100%;
  position: relative;
  height: var(--footer-height);
}
.custom-footer {
  position: fixed;
  overflow: hidden;
  display: flex;
  z-index: var(--z-index-footer);

  bottom: var(--safe-area-inset-bottom);
  box-shadow: 0px 0px 2px 0px var(--clr-black-0);

  width: 100%;
  height: var(--footer-height);
  background: var(--clr-black-1);
  &_menu-icon {
    min-width: 48px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--clr-grey-2);
    font-size: 1.5rem;
  }
  &_nav-tabs {
    align-items: unset;
    justify-content: unset;
    width: calc(100vw - 48px);
    overflow-x: auto;
    overflow-y: hidden;
    position: absolute;
    right: 0;
    height: var(--footer-height);
  }
}
.logo-text {
  fill: var(--clr-white-0);
  padding: 1rem;
  display: flex;
  align-items: center;
  span {
    padding: 0 0 0 1.1rem;
    font-weight: 500;
    justify-content: flex-start;
    color: white !important;
  }
  &:hover {
    color: var(--clr-primary) !important;
  }
}
.router-link-exact-active {
  fill: var(--clr-primary) !important;
}
.footer-drawer {
  overflow: auto;
  position: fixed;
  z-index: var(--z-index-footer-drawer);
  top: 0;
  height: var(--vh-100);
  background: var(--clr-black-1);

  max-width: 22rem;
  min-width: 18rem;
  margin-left: -22rem;
  transition: 0.2s;
  &_open {
    margin-left: 0;
  }
  &_overlay {
    position: fixed;
    width: 100vw;
    top: 0;
    left: -100vw;
    height: var(--vh-100);
    transition: background 0.3s;
    z-index: 1;
    &_visible {
      left: 0;
      background: rgba(0, 0, 0, 0.6);
    }
  }
}

.notifCircle {
  position: absolute;
  border-radius: 1rem;
  top: 0;
  right: 0;
  transform: translate(50%, 0);
  font-size: 0.7rem;
  z-index: 4;
  color: black;
  background: var(--clr-primary);
  padding: 2px;
  min-width: 0.875rem;
  text-align: center;
  box-shadow: var(--menu-shadow);
  height: 1rem;
  line-height: 1;
}
</style>
